var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var PLAYLIST_CHECK_TIMEOUT_MS = 3000;
var VIDEO_CODEC = /\b(avc1|avc3|hvc1|hev1|dvh1|dvhe|av01|vp09)\./;
/**
 * What a master playlist declares. Variants without a resolution or a video codec are audio-only, which is more
 * reliable than the player's video dimensions: iOS Safari reports 1280x720 for audio-only HLS.
 */
export var parsePlaylist = function (playlist) {
    var lines = playlist.split(/\r?\n/);
    var variants = lines.filter(function (line) { return line.startsWith('#EXT-X-STREAM-INF:'); });
    var hasCaptions = lines.some(function (line) { return line.startsWith('#EXT-X-MEDIA:') && line.includes('TYPE=SUBTITLES'); });
    if (variants.length === 0)
        return { isAudioOnly: null, hasCaptions: hasCaptions };
    var isAudioOnly = variants.every(function (variant) { return !variant.includes('RESOLUTION=') && !VIDEO_CODEC.test(variant); });
    return { isAudioOnly: isAudioOnly, hasCaptions: hasCaptions };
};
/**
 * Loads an HLS playlist, or null if it can't be loaded right now, so a player can fall back to Mux's own playlist
 * instead of erroring. Any failure counts: a non-2xx (the caption proxy 404s a source it won't serve), a network
 * error, or no answer within the timeout.
 */
export var loadPlaylist = function (src_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([src_1], args_1, true), void 0, function (src, timeoutMs) {
        var signal, response, playlist, _a;
        if (timeoutMs === void 0) { timeoutMs = PLAYLIST_CHECK_TIMEOUT_MS; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    signal = AbortSignal.timeout(timeoutMs);
                    return [4 /*yield*/, fetch(src, { signal: signal })];
                case 1:
                    response = _b.sent();
                    if (!response.ok)
                        return [2 /*return*/, null];
                    return [4 /*yield*/, response.text()];
                case 2:
                    playlist = _b.sent();
                    return [2 /*return*/, parsePlaylist(playlist)];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
};
